var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-top" },
    [
      _c(
        "svg",
        {
          staticClass: "icon",
          attrs: { slot: "image", "aria-hidden": "true" },
          on: {
            click: function($event) {
              _vm.$route.path == "/purchase" ? _vm.$router.push("/index") : ""
            }
          },
          slot: "image"
        },
        [_c("use", { attrs: { "xlink:href": "#icon-logo2" } })]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "language-popup",
          style: { height: "50%" },
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.vanPopupShow,
            callback: function($$v) {
              _vm.vanPopupShow = $$v
            },
            expression: "vanPopupShow"
          }
        },
        [
          _c(
            "div",
            { staticClass: "popup-title" },
            [
              _vm._v(_vm._s(_vm.$t("300063")) + "\n      "),
              _c("van-icon", {
                attrs: { name: "cross" },
                on: {
                  click: function($event) {
                    _vm.vanPopupShow = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "language-list" },
            _vm._l(_vm.languageList, function(item, index) {
              return _c(
                "p",
                {
                  key: index,
                  staticClass: "list-item",
                  on: {
                    click: function($event) {
                      return _vm.changeLanguage(item)
                    }
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(item.name) + "\n        "),
                  _c("van-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.language == item.language,
                        expression: "language == item.language"
                      }
                    ],
                    attrs: { name: "success" }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "language-popup",
          style: { height: "50%" },
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.moreModel,
            callback: function($$v) {
              _vm.moreModel = $$v
            },
            expression: "moreModel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "popup-title more-title" },
            [
              _c("van-icon", {
                attrs: { name: "cross" },
                on: {
                  click: function($event) {
                    _vm.moreModel = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.token
            ? _c("div", { staticClass: "more-user" }, [
                _vm.user.email && _vm.user.iphone
                  ? _c("p", [_vm._v(_vm._s(_vm.user.email))])
                  : _vm.user.email
                  ? _c("p", [_vm._v(_vm._s(_vm.user.email))])
                  : _c("p", [_vm._v(_vm._s(_vm.user.iphone))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("ID:" + _vm._s(_vm.user.id)),
                  _c("i", {
                    staticClass: "copy iconfont icon-fuzhi",
                    attrs: { "data-clipboard-text": _vm.user.id },
                    on: { click: _vm.handleCopy }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "more-language" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("300063")))]),
            _vm._v(" "),
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    _vm.vanPopupShow = true
                  }
                }
              },
              [
                _vm._v(_vm._s(_vm.languageName) + " "),
                _c("i", { staticClass: "iconfont icon-xiala" })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "more-download",
              on: {
                click: function($event) {
                  return _vm.$router.push("/download")
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("300332")))])]
          ),
          _vm._v(" "),
          !_vm.token
            ? _c(
                "div",
                { staticClass: "btn_box" },
                [
                  _c("van-button", { on: { click: _vm.toLogin } }, [
                    _vm._v(_vm._s(_vm.$t("300169")))
                  ]),
                  _vm._v(" "),
                  _c("van-button", { on: { click: _vm.toRegister } }, [
                    _vm._v(_vm._s(_vm.$t("300041")))
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8012b4bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8012b4bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHeaderTop.vue
// module id = PmUw
// module chunks = 0